import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const initialForm = {
  name: "",
  email: "",
  phone: "",
  service: "",
  message: "",
};

/**
 * Encapsulates the contact form state, prefill listener and submission flow.
 * Returns the form state, change/submit handlers, status and loading flags.
 */
export function useContactForm() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState({ type: null, text: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handler = (e) =>
      setForm((f) => ({ ...f, service: e.detail }));
    window.addEventListener("prefill-service", handler);
    return () => window.removeEventListener("prefill-service", handler);
  }, []);

  const update = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: null, text: "" });
    try {
      await axios.post(`${API}/contact`, {
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        message: form.message.trim(),
        service: form.service?.trim() || null,
      });
      setStatus({
        type: "ok",
        text: "Mensaje enviado. Te contactaremos en menos de 24 horas.",
      });
      setForm(initialForm);
    } catch (err) {
      const data = err?.response?.data?.detail;
      let detail = "No se pudo enviar el mensaje. Intenta nuevamente.";
      if (typeof data === "string") {
        detail = data;
      } else if (Array.isArray(data) && data.length > 0) {
        // FastAPI/Pydantic validation errors come as array of {loc, msg, type, ...}
        detail = data
          .map((e) => (typeof e === "string" ? e : e?.msg || "Campo inválido"))
          .join(". ");
      } else if (data && typeof data === "object" && data.msg) {
        detail = data.msg;
      }
      setStatus({ type: "error", text: detail });
    } finally {
      setLoading(false);
    }
  };

  return { form, update, submit, status, loading };
}
